import { render, staticRenderFns } from "./layoutHeader.vue?vue&type=template&id=56dd34e7&scoped=true&"
import script from "./layoutHeader.vue?vue&type=script&lang=js&"
export * from "./layoutHeader.vue?vue&type=script&lang=js&"
import style0 from "./layoutHeader.vue?vue&type=style&index=0&id=56dd34e7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dd34e7",
  null
  
)

export default component.exports